module.exports = __webpack_public_path__ + "img/house-for-sale.fe0d9c50.jpg";